class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", (event) => {
            event.preventDefault();
            const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();
        // this.getCartData();
        this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

        // this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        //     (total, quantityInput) => total + parseInt(quantityInput.value),
        //     0
        // );

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener("change", this.debouncedOnChange.bind(this));
        console.dir(this);
        // this.querySelector('[action="/cart"]').addEventListener("submit", this.onSubmit.bind(this));
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
    }

    getSectionsToRender() {
        return [
            {
                id: "main-cart-items",
                section: document.getElementById("main-cart-items").dataset.id,
                selector: [".js-contents-main", ".js-contents-block", "#free-shipping-wrapper", ".js-cart-checkout"],
                // selector: [".js-contents-main", ".js-contents-block", ".js-contents-shipping", ".js-contents-count"],
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: [".js-cart-icon-bubble"],
            },
            {
                id: "cart-live-region-text",
                section: "cart-live-region-text",
                selector: [".shopify-section"],
            },
            // {
            //   id: 'main-cart-footer',
            //   section: document.getElementById('main-cart-footer').dataset.id,
            //   selector: '.js-contents',
            // }
        ];
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);
        // debugger;
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                console.log(parsedState);
                this.renderContents(parsedState, line, name);
            })
            .catch((e) => {
                console.error(e);
                this.querySelectorAll(".loading-overlay").forEach((overlay) => overlay.classList.add("hidden"));
                const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
                errors.textContent = window.cartStrings.error;
            })
            .finally(() => {
                this.disableLoading(line);
            });
    }
    renderContents(parsedState, currentLine = 0, name = "") {
        // this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartMainWrapper = document.querySelector("#main-cart-items");
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");
        const quantityElement = document.getElementById(`Quantity-${currentLine}`) || document.getElementById(`Drawer-quantity-${currentLine}`);
        if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute("value");
            this.updateLiveRegions(currentLine, parsedState.errors);
            return;
        }
        if (cartMainWrapper) cartMainWrapper.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
            section.selector.forEach((sel) => {
                const elementToReplace = document.getElementById(section.id).querySelector(sel);
                // const elementToReplace = document.getElementById(section.id).querySelector(sel) || document.getElementById(section.id);
                if (elementToReplace) elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], sel);
            });
        });

        const lineItem = document.getElementById(`CartItem-${currentLine}`) || document.getElementById(`CartDrawer-Item-${currentLine}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector(".drawer__inner-empty"), cartDrawerWrapper.querySelector("a"));
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
        }
        if (cartDrawerWrapper) cartDrawerWrapper.updateShippingDrawer(parsedState);
        // this.disableLoading();
    }

    updateLiveRegions(line, errors) {
        let message = errors;
        // if (this.currentItemCount === errors) {
        //     message = window.cartStrings.quantityError.replace("[quantity]", quantityElement.value);
        // } else {
        //     message = errors;
        // }
        const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        if (lineItemError) {
            lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
        } else {
            alert(message);
        }
        let lineItemRemove = document.querySelector(`#CartItem-${line} cart-remove-button`) || document.querySelector(`#CartDrawer-Item-${line} cart-remove-button`);
        if (lineItemRemove && errors.includes("already sold out")) {
            lineItemRemove.classList.add("alert-remove");
        }

        // if (Number(errors) != NaN) {
        //     this.currentItemCount = errors;
        // }
        this.lineItemStatusElement.setAttribute("aria-hidden", true);

        const cartStatus = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.add("cart__items--disabled");

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove("hidden"));

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }

    disableLoading(line) {
        const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.remove("cart__items--disabled");

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.add("hidden"));
    }

    // getCartData() {
    //     this.cartData =
    //         this.cartData || JSON.parse(this.querySelector('[type="application/json"]') ? this.querySelector('[type="application/json"]').textContent : null);
    //     return this.cartData;
    // }
    // onSubmit(e) {
    //     e.preventDefault();
    //     let paramCart = "&cart_token=" + (document.cookie.match("(^|; )cart=([^;]*)") || 0)[2];
    //     if (JSON.stringify(this.cartData.items).indexOf("shipping_interval_frequency") > -1) {
    //         let paramDomain = `myshopify_domain=${this.dataset.domain}`;
    //         let paramLinker;
    //         try {
    //             paramLinker = "&" + ga.getAll()[0].get("linkerParam");
    //         } catch (err) {
    //             paramLinker = "";
    //         }
    //         let paramCustomer = this.dataset.customerEmail ? this.dataset.customerEmail : "";
    //         window.location = "https://checkout.rechargeapps.com/r/checkout?" + paramDomain + paramCart + paramLinker + paramCustomer;
    //     } else {
    //         window.location = "/checkout";
    //     }
    // }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
    customElements.define(
        "cart-note",
        class CartNote extends HTMLElement {
            constructor() {
                super();

                this.addEventListener(
                    "change",
                    debounce((event) => {
                        const body = JSON.stringify({ note: event.target.value });
                        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
                    }, 300)
                );
            }
        }
    );
}
class ShippingRate extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
        this.button = this.querySelector('button[type="submit"]');
        this.inputCountry = this.querySelector('[name="shipping_address[country]"]');
        this.inputProvince = this.querySelector('[name="shipping_address[province]"]');
        this.freeShipping = this.querySelector("#free-shipping-wrapper");
        this.config = {
            customerIsLoggedIn: this.hasAttribute("data-customer"),
            submitButton: this.dataset.button,
            submitButtonDisabled: this.dataset.buttonLoading,
        };
        this.countryHandle();
        this.form.addEventListener("submit", this.submitHandle.bind(this));
        this.inputCountry.addEventListener("change", this.countryHandle.bind(this));
        this.closest(".loading").classList.remove("loading");
    }
    countryHandle() {
        this.reset();
        let _thisSelect = this.inputCountry.selectedOptions[0];
        let value = JSON.parse(_thisSelect.dataset.provinces);
        this.inputProvince.innerHTML = "";
        value.forEach((option) => {
            let op = document.createElement("option");
            op.text = option[0];
            op.value = option[1];
            this.inputProvince.add(op);
        });
        this.inputProvince.parentElement.style.display = value.length > 0 ? "" : "none";
    }
    async submitHandle(e) {
        e.preventDefault();
        const form = e.currentTarget.closest("form");
        const formData = new FormData(form);
        this.address = [formData.get("shipping_address[zip]"), formData.get("shipping_address[province]"), formData.get("shipping_address[country]")]
            .filter((el) => el != null && el != "")
            .join(", ");

        this.reset();
        this.disableButton();
        let check = await this.getCartShippingRatesForDestination(formData);
        this.freeShipping && !check && (this.freeShipping.style.display = "");
        setTimeout(() => this.enableButton(), 500);
    }

    async getCartShippingRatesForDestination(formData) {
        let paramData = new URLSearchParams(formData).toString();
        let url = `/cart/prepare_shipping_rates.json?${paramData}`;
        return await fetch(url, {
            method: "POST",
        })
            .then((r) => r.json())
            .then(async (data) => {
                if (data) this.catchError(data);
                else await this.pollForCartShippingRatesForDestination(paramData);
                return data;
            })
            .catch((e) => console.error(e));
    }

    async pollForCartShippingRatesForDestination(paramData) {
        let url = `/cart/async_shipping_rates.json?${paramData}`;
        let a = await fetch(url)
            .then((r) => r.json())
            .then((d) => {
                if (d) this.returnMessage(d);
                else return true;
                return false;
            })
            .catch((e) => console.error(e));
        if (a) setTimeout(this.pollForCartShippingRatesForDestination(paramData), 5000);
        else return a;
    }

    reset() {
        this.querySelectorAll("input, select").forEach((el) => el.classList.remove("error"));
        this.querySelectorAll(".field__label-error").forEach((el) => (el.textContent = ""));
        this.querySelector("#shipping_rates").innerHTML = "";
        this.freeShipping && (this.freeShipping.style.display = "none");
    }
    catchError(data) {
        Object.entries(data).forEach((key) => {
            this.querySelector(`[name="shipping_address[${key[0]}]"]`).classList.add("error");
            this.querySelector(`#shipping_address_${key[0]}-error`).textContent = key[1].map((k) => k).join(". ");
        });
    }
    formatMoney(number) {
        let locale = `${Shopify.locale}-${Shopify.country}`;
        let money = new Intl.NumberFormat(locale, { style: "currency", currency: Shopify.currency.active }).format(number * Shopify.currency.rate);
        return money + " " + Shopify.currency.active;
    }
    returnMessage(data) {
        let text = this.textConfig;
        Object.keys(data).forEach((key) => {
            let html = "";
            let rates = data[key];
            if (rates.length > 1) {
                html += `<p>${text.ratesLengthMoreThanOne
                    .replace("<%= rates.length %>", rates.length)
                    .replace("<%= address %>", this.address)
                    .replace("<%= rates.price %>", this.formatMoney(rates[0].price))}</p>`;
            } else if (rates.length == 1) {
                html += `<p>${text.ratesLengthOne.replace("<%= address %>", this.address)}</p>`;
            } else {
                html += `<p>${text.ratesLengthZero}</p>`;
            }
            if (rates.length > 0) {
                html += `<ul>`;
                rates.forEach((rate) => {
                    html += `<li>${text.singleRate.replace("<%= rate.name %>", rate.name).replace("<%= rate.price %>", this.formatMoney(rate.price))} </li>`;
                });
                html += `</ul>`;
            }
            this.querySelector(`#${key}`).innerHTML = html;
        });
        return;
    }
    enableButton() {
        this.button.classList.remove("loading");
        this.button.disabled = false;
        this.button.textContent = this.config.submitButton;
    }
    disableButton() {
        this.button.classList.add("loading");
        this.button.disabled = true;
        this.button.textContent = this.config.submitButtonDisabled;
    }
}

customElements.define("shipping-rate", ShippingRate);
